const meatSeafood = [];
meatSeafood.push();

export default meatSeafood;